<template>
  <div>
    <the-headersider></the-headersider>
    
    <div class="dashboard-container">
      <!-- Dashboard Header -->
      <div class="dashboard-header">
        <div class="d-flex align-items-center">
          <div class="dashboard-icon">
            <i class="bi bi-speedometer2"></i>
          </div>
          <div>
            <h1 class="dashboard-title">Dashboard</h1>
            <p class="dashboard-subtitle">Greenbelt Life Africa - Overview</p>
          </div>
        </div>
        <div class="current-date">
          <i class="bi bi-calendar-check me-2"></i>
          {{ currentDate }}
        </div>
      </div>


      <!-- Month Filter -->
      <div class="dashboard-filter d-flex align-items-center gap-2 mt-3">
        <label for="month-filter" class="mb-0">
          <i class="bi bi-calendar3 me-1"></i>Filter by month:
        </label>
        <input
          id="month-filter"
          type="month"
          class="form-control form-control-sm w-auto"
          v-model="selectedMonth"
        />
        <button
          v-if="selectedMonth"
          class="btn btn-sm btn-outline-secondary"
          @click="clearMonthFilter"
        >
          Clear
        </button>
      </div>

      <br>
      <br>

      <!-- Stats Cards -->
      <div class="row g-4">
        <!-- Clients Card -->
        <div class="col-xl-2 col-md-4 col-sm-6">
          <div class="stats-card clients-card">
            <div class="card-icon">
              <i class="bi bi-people-fill"></i>
            </div>
            <div class="card-content">
              <div class="card-value">{{ clients.length }}</div>
              <div class="card-label">Total Clients</div>
              <div class="card-desc">Registered clients</div>
            </div>
            <div class="card-trend up">
              <i class="bi bi-arrow-up-short"></i>
              <span>Active</span>
            </div>
          </div>
        </div>

        <!-- estates Card -->
        <!-- <div class="col-xl-2 col-md-4 col-sm-6">
          <div class="stats-card estates-card">
            <div class="card-icon">
              <i class="bi bi-house-door-fill"></i>
            </div>
            <div class="card-content">
              <div class="card-value">{{ estates.length }}</div>
              <div class="card-label">Estates Served</div>
              <div class="card-desc">Service areas</div>
            </div>
            <div class="card-trend stable">
              <i class="bi bi-dash"></i>
              <span>Growing</span>
            </div>
          </div>
        </div> -->

        <!-- Revenue Card -->
        <div class="col-xl-2 col-md-4 col-sm-6">
          <div class="stats-card revenue-card">
            <div class="card-icon">
              <i class="bi bi-cash-stack"></i>
            </div>
            <div class="card-content">
              <div class="card-value">Ksh {{ formatNumber(total_collected) }}</div>
              <div class="card-label">Revenue</div>
              <div class="card-desc">Collected & allocated</div>
            </div>
            <div class="card-trend up">
              <i class="bi bi-arrow-up-short"></i>
              <span>Good</span>
            </div>
          </div>
        </div>

        <!-- M-Pesa Card -->
        <div class="col-xl-2 col-md-4 col-sm-6">
          <div class="stats-card mpesa-card">
            <div class="card-icon">
              <i class="bi bi-phone-fill"></i>
            </div>
            <div class="card-content">
              <div class="card-value">Ksh {{ formatNumber(unAllocatedMpesa) }}</div>
              <div class="card-label">M-Pesa Balance</div>
              <div class="card-desc">Unallocated payments</div>
            </div>
            <div class="card-trend warning">
              <i class="bi bi-exclamation-triangle"></i>
              <span>Pending</span>
            </div>
          </div>
        </div>

        <!-- Arrears Card -->
        <div class="col-xl-2 col-md-4 col-sm-6">
          <div class="stats-card arrears-card">
            <div class="card-icon">
              <i class="bi bi-clock-history"></i>
            </div>
            <div class="card-content">
              <div class="card-value">Ksh {{ formatNumber(total_arrears) }}</div>
              <div class="card-label">Outstanding</div>
              <div class="card-desc">Arrears to collect</div>
            </div>
            <div class="card-trend down">
              <i class="bi bi-arrow-down-short"></i>
              <span>Due</span>
            </div>
          </div>
        </div>

              <!--overpayment -->
        <div class="col-xl-2 col-md-4 col-sm-6">
          <div class="stats-card arrears-card">
            <div class="card-icon">
              <i class="bi bi-clock-history"></i>
            </div>
            <div class="card-content">
              <div class="card-value">Ksh {{ formatNumber(total_overpayment) }}</div>
              <div class="card-label">Overpayment</div>
              <div class="card-desc">Yet to be billed</div>
            </div>
            <div class="card-trend up">
              <i class="bi bi-arrow-up-short"></i>
              <span>More</span>
            </div>
          </div>
        </div>

        <!-- Monthly Projections -->
        <div class="col-xl-2 col-md-4 col-sm-6">
          <div class="stats-card monthly-card">
            <div class="card-icon">
              <i class="bi bi-graph-up"></i>
            </div>
            <div class="card-content">
              <div class="card-value">Ksh {{ formatNumber(monthly_collections) }}</div>
              <div class="card-label">Monthly Target</div>
              <div class="card-desc">Projected revenue</div>
            </div>
            <div class="card-trend stable">
              <i class="bi bi-target"></i>
              <span>On track</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Summary Section -->
      <div class="row mt-5">
        <div class="col-12">
          <div class="summary-card">
            <div class="summary-header">
              <h3><i class="bi bi-info-circle me-2"></i>Business Summary</h3>
              <div class="summary-period">Current Month</div>
            </div>
            <div class="summary-content">
              <div class="summary-item">
                <div class="summary-label">
                  <i class="bi bi-check-circle-fill text-success me-2"></i>
                  Client Satisfaction
                </div>
                <div class="summary-progress">
                  <div class="progress-bar" style="width: 92%"></div>
                  <span class="progress-value">92%</span>
                </div>
              </div>
              <div class="summary-item">
                <div class="summary-label">
                  <i class="bi bi-truck text-primary me-2"></i>
                  Collection Efficiency
                </div>
                <div class="summary-progress">
                  <div class="progress-bar" style="width: 88%"></div>
                  <span class="progress-value">88%</span>
                </div>
              </div>
              <div class="summary-item">
                <div class="summary-label">
                  <i class="bi bi-recycle text-success me-2"></i>
                  Waste Recycled
                </div>
                <div class="summary-progress">
                  <div class="progress-bar" style="width: 76%"></div>
                  <span class="progress-value">76%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Quick Stats -->
      <div class="row mt-4">
        <div class="col-md-4">
          <div class="quick-stat">
            <div class="quick-stat-icon avg-revenue">
              <i class="bi bi-currency-exchange"></i>
            </div>
            <div class="quick-stat-content">
              <div class="quick-stat-value">Ksh {{ formatNumber(avgRevenue) }}</div>
              <div class="quick-stat-label">Average Revenue per Client</div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="quick-stat">
            <div class="quick-stat-icon avg-clients">
              <i class="bi bi-person-plus"></i>
            </div>
            <div class="quick-stat-content">
              <div class="quick-stat-value">{{ avgNewClients }}</div>
              <div class="quick-stat-label">New Clients per Month</div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="quick-stat">
            <div class="quick-stat-icon collection-rate">
              <i class="bi bi-percent"></i>
            </div>
            <div class="quick-stat-content">
              <div class="quick-stat-value">{{ collectionRate }}%</div>
              <div class="quick-stat-label">Payment Collection Rate</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer Note -->
      <div class="dashboard-footer">
        <div class="footer-note">
          <i class="bi bi-lightbulb me-2"></i>
          <span>Data last updated: {{ lastUpdated }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data(){
    return{
      //YYYY-MM
      selectedMonth:''
    }
  },

  computed: {

    clients() {
      return this.$store.getters.clients;
    },
    payments() {
      return this.$store.getters.payments;
    },
    unallocatedPayments() {
      return this.$store.getters.unAllocatedMpesaPayments();
    },
    estates() {
      return this.$store.getters.estates;
    },
    id_client() {
      return this.client_id + 1;
    },


    filteredPayments(){
      if(!this.selectedMonth) return this.payments;
      return this.payments.filter(
        p => p.payment_date && p.payment_date.slice(0, 7) === this.selectedMonth
      );
    },

    filteredUnallocatedPayments(){
      if(!this.selectedMonth) return this.unallocatedPayments;
      return this.unallocatedPayments.filter(
        p => p.payment_date && p.payment_date.slice(0, 7) === this.selectedMonth
      );
    },


    total_collected() {
      return this.filteredPayments.reduce((total, item) => total + item.amount, 0);
    },

    unAllocatedMpesa() {
      return this.filteredUnallocatedPayments.reduce(
        (total, item) => total + Math.round(item.amount), 
      0);
    },

    paidByClientThisMonth(){
      const map = {};
      for (const p of this.filteredPayments){
        map[p.clientId] = (map[p.clientId] || 0) + Number(p.amount);
      }
      return map;
     },

     debtorsThisMonth(){
      return this.clients.map(client => {
        const paid = this.paidByClientThisMonth[client.id] || 0;
        const expected = Number(client.montlyPayment) || 0;
        return{
          clientId: client.id,
          name:client.name,
          expected,
          paid,
          balance:expected - paid //
        };
      });
     },

     total_arreas_this_month(){
      return this.debtorsThisMonth.filter(
        c => c.balance > 0).reduce(
          (total, c) => total + c.balance, 0
        );
     },

    total_overpayment() {
      
       if (this.selectedMonth) {
        return this.debtorsThisMonth
          .filter(c => c.balance < 0)
          .reduce((total, c) => total + Math.abs(c.balance), 0);
      }
      return this.clients
        .filter(client => Number(client.arrears) < 0)
        .reduce((total, client) => {
          return total + Math.abs(Number(client.arrears));
        }, 0);
    },
    total_arrears() {
      if(this.selectedMonth){
        return this.debtorsThisMonth.filter(c=> c.balance > 0).reduce(
          (total, c) => total + c.balance, 0
        );
      }
      return this.clients.reduce((total, item) => total + item.arrears, 0);
    },
    monthly_collections() {
      return this.clients.reduce((total, item) => total + item.montlyPayment, 0);
    },
    
    // Simple computed values for display
    avgRevenue() {
      return this.clients.length > 0 ? Math.round(this.total_collected / this.clients.length) : 0;
    },
    avgNewClients() {
      return Math.round(this.clients.length / 12); // Assuming 12 months of operation
    },
    collectionRate() {
      const totalOwed = this.monthly_collections;
      const collected = this.total_collected;
      return totalOwed > 0 ? Math.round((collected / totalOwed) * 100) : 100;
    },
    currentDate() {
      return new Date().toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    lastUpdated() {
      return new Date().toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  },
  
  methods: {
    formatNumber(num) {
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M';
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'K';
      }
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    setMonthFilter(month){
      this.selectedMonth = month;
    },

    clearMonthFilter(){
      this.selectedMonth = '';
    },
  },
  
  created() {
    this.$store.dispatch('LoadClients');
    this.$store.dispatch('LoadEstates');
    this.$store.dispatch('LoadPayments');
    this.$store.dispatch('LoadMpesapayments');
  },
};
</script>

<style scoped>
.dashboard-container {
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
  min-height: 100vh;
}

/* Header Styles */
.dashboard-header {
  background: white;
  padding: 25px;
  border-radius: 15px;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
}

.dashboard-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #28a745, #20c997);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  font-size: 28px;
  color: white;
}

.dashboard-title {
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 5px;
}

.dashboard-subtitle {
  color: #6c757d;
  font-size: 15px;
}

.current-date {
  background: #f8f9fa;
  padding: 10px 20px;
  border-radius: 10px;
  font-weight: 500;
  color: #495057;
}

/* Stats Cards */
.stats-card {
  background: white;
  padding: 25px;
  border-radius: 15px;
  position: relative;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  height: 100%;
  border-top: 4px solid transparent;
}

.stats-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
}

.clients-card { border-top-color: #667eea; }
.estates-card { border-top-color: #f093fb; }
.revenue-card { border-top-color: #4facfe; }
.mpesa-card { border-top-color: #43e97b; }
.arrears-card { border-top-color: #fa709a; }
.monthly-card { border-top-color: #30cfd0; }

.card-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  font-size: 24px;
  color: white;
}

.clients-card .card-icon { background: linear-gradient(135deg, #667eea, #764ba2); }
.estates-card .card-icon { background: linear-gradient(135deg, #f093fb, #f5576c); }
.revenue-card .card-icon { background: linear-gradient(135deg, #4facfe, #00f2fe); }
.mpesa-card .card-icon { background: linear-gradient(135deg, #43e97b, #38f9d7); }
.arrears-card .card-icon { background: linear-gradient(135deg, #fa709a, #fee140); }
.monthly-card .card-icon { background: linear-gradient(135deg, #30cfd0, #330867); }

.card-value {
  font-size: 32px;
  font-weight: 700;
  color: #2c3e50;
  line-height: 1;
  margin-bottom: 8px;
}

.card-label {
  font-size: 16px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 5px;
}

.card-desc {
  font-size: 13px;
  color: #6c757d;
  opacity: 0.8;
}

.card-trend {
  position: absolute;
  top: 25px;
  right: 25px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

.card-trend.up {
  background: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.card-trend.down {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.card-trend.stable {
  background: rgba(108, 117, 125, 0.1);
  color: #6c757d;
}

.card-trend.warning {
  background: rgba(255, 193, 7, 0.1);
  color: #ffc107;
}

/* Summary Card */
.summary-card {
  background: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
}

.summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e9ecef;
}

.summary-header h3 {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.summary-period {
  background: #f8f9fa;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #495057;
}

.summary-item {
  margin-bottom: 20px;
}

.summary-item:last-child {
  margin-bottom: 0;
}

.summary-label {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #495057;
  margin-bottom: 10px;
}

.summary-progress {
  display: flex;
  align-items: center;
  gap: 15px;
}

.summary-progress .progress-bar {
  flex: 1;
  height: 10px;
  background: #e9ecef;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}

.summary-progress .progress-bar::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(90deg, #28a745, #20c997);
  border-radius: 5px;
}

.summary-progress .progress-value {
  min-width: 50px;
  text-align: right;
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
}

/* Quick Stats */
.quick-stat {
  background: white;
  padding: 20px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  height: 100%;
}

.quick-stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  font-size: 24px;
  color: white;
}

.avg-revenue { background: linear-gradient(135deg, #667eea, #764ba2); }
.avg-clients { background: linear-gradient(135deg, #f093fb, #f5576c); }
.collection-rate { background: linear-gradient(135deg, #4facfe, #00f2fe); }

.quick-stat-value {
  font-size: 22px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 5px;
}

.quick-stat-label {
  font-size: 14px;
  color: #6c757d;
}

/* Footer */
.dashboard-footer {
  margin-top: 40px;
  text-align: center;
  padding: 20px;
}

.footer-note {
  display: inline-flex;
  align-items: center;
  background: #f8f9fa;
  padding: 10px 20px;
  border-radius: 25px;
  font-size: 14px;
  color: #6c757d;
}

/* Responsive */
@media (max-width: 768px) {
  .dashboard-header {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }
  
  .dashboard-icon {
    margin-right: 0;
    margin-bottom: 15px;
  }
  
  .current-date {
    font-size: 14px;
  }
  
  .card-value {
    font-size: 24px;
  }
  
  .quick-stat {
    flex-direction: column;
    text-align: center;
  }
  
  .quick-stat-icon {
    margin-right: 0;
    margin-bottom: 15px;
  }
}
</style>